module.exports = __webpack_public_path__ + "media/images/locked-listing-new-47835ede74fde2063436ce78e08cd27b.jpg";